{
  "incidentsOverview": {
    "button": {
      "new": "Neues Lawinenereignis",
      "columns": "Spalten",
      "download": "GeoJSON herunterladen"
    },
    "tooltip": {
      "edit": "Lawinenereignis bearbeiten",
      "preview": "Lawinenereignis anzeigen"
    },
    "empty": "Keine Lawinenereignisse für diese Region.",
    "loading": "Lawinenereignisse werden geladen...",
    "error": "Lawinenereignisse konnten nicht geladen werden",
    "retry": "Wiederholen",
    "filter": {
      "anyStatus": "Status auswählen"
    }
  },
  "incidentReportUI": {
    "addAttachment": "Anhang hochladen",
    "addAvalancheProblem": "Lawinenproblem hinzufügen",
    "addGroup": "Gruppe hinzufügen",
    "addVictim": "Person hinzufügen",
    "back": "Zurück",
    "clearLine": "Linie löschen",
    "clearPoint": "Punkt löschen",
    "clearPolygon": "Polygon löschen",
    "controls": "Regler Geometrie",
    "deleteIncident": "Lawinenereignis löschen",
    "deleteIncidentConfirm": "Willst du wirklich dieses Lawinenereignis löschen?",
    "drawLine": "Linie zeichnen",
    "drawLineInstructions": "Um der Linie Punkte hinzuzufügen, bitte In die Karte klicken.",
    "drawPoint": "Punkt zeichnen",
    "drawPointInstructions": "Zum Setzen der Ortsmarkierung einfach auf eine beliebige Stelle auf der Karte klicken und sie dann an die gewünschte Position ziehen.",
    "drawPolygon": "Polygon zeichnen",
    "drawPolygonInstructions": "Mit Klick auf die Karte werden die Eckpunkte des Polygons festgelegt.",
    "dropAttachment": "Drop Anhang {{fileName}}?",
    "dropAvalancheProblem": "Lawinenproblem {{number}} löschen?",
    "dropGroup": "Drop Gruppe {{number}}?",
    "dropVictim": "Person {{number}} löschen?",
    "fetchPublishedBulletin": "Aus veröffentlichtem CAAML-Bulletin übernehmen.",
    "fetchPublishedBulletinError": "Für {{region}} am {{date}} wurde kein veröffentlichtes CAAML-Bulletin gefunden.",
    "fetchPublishedBulletinSuccess": "Aktualisierte Bulletin-Informationen mit {{count}} Lawinenproblemen für {{region}} am {{date}}.",
    "groupName": "Gruppe {{name}}",
    "groupUnknown": "Gruppe nicht bekannt",
    "incomplete": "Unvollständig",
    "line": "Linie",
    "locationMap": "Karte für die Örtlichkeit",
    "noGroups": "Keine Gruppen vorhanden. Klicke auf „Gruppe hinzufügen“, um eine Gruppe anzulegen.",
    "next": "Nächste",
    "overview": "Überblick",
    "noVictims": " Es sind keine Personen registriert. Klicken Sie auf „Person hinzufügen“.",
    "point": "Punkt",
    "polygon": "Polygon",
    "publishIncident": "Publizieren",
    "publishIncidentConfirm": "Willst du dieses Lawinenereignis publizieren?",
    "publishIncidentSuccess": "Lawinenereignis wurde erfolgreich publiziert",
    "republishIncident": "Erneut publizieren:",
    "republishIncidentConfirm": "Willst du dieses Lawinenereignis erneut publizieren?",
    "unpublishIncident": "Löschen",
    "unpublishIncidentConfirm": "Willst du dieses Lawinenereignis löschen?",
    "unpublishIncidentSuccess": "Die Lawinenereignis wurde erfolgreich gelöscht.",
    "removeAttachment": "Anhang löschen",
    "removeAvalancheProblem": "Lawinenproblem löschen",
    "removeGroup": "Gruppe löschen",
    "removeVictim": "Person löschen",
    "requiredFieldsMissingHint": "Die Dokumentation kann erst gespeichert und der Status erst geändert werden, wenn alle Pflichtfelder (im Formular gekennzeichnet) ausgefüllt sind.",
    "displayMode": {
      "edit": "Bearbeiten",
      "editMostRelevant": "Die wichtigsten Ergebnisse bearbeiten",
      "all": "Vorschau alle Ergebnisse",
      "public": "Vorschau nur öffentliche",
      "filledOut": "Vorschau nur ausgefüllte"
    },
    "victimName": "Person {{name}}",
    "saveStateSaving": "Speichern ...",
    "saveStateSaved": "Erfolgreich gespeichert",
    "saveStateError": "Fehler beim Speichern",
    "saveStateBlocked": "Pflichtfelder wurden nicht ausgefüllt"
  },
  "incidentReport": {
    "incidentReport": "Ereignisdokumentation",
    "metaInformation": "Metadaten",
    "generalInformation": "Allgemeine Informationen",
    "bulletinInformation": "Information zum Lawinenbericht",
    "locationInformation": "Informationen zum Ort",
    "avalancheInformation": "Informationen zur Lawine",
    "groupInformation": "Informationen zur Gruppe",
    "victimInformation": "Informationen zur Person",
    "involvementsFatalitiesBurials": "Beteiligungen, Todesopfer und Verschüttungen",
    "incidentAnalysis": "Ereignisanalyse",
    "incidentAttachments": "Anhänge und Links",
    "author": "Autor",
    "authorAffiliation": "Organisation des Autors",
    "dateTime": "Datum/Zeit",
    "updatedAt": "Letztes Update",
    "publishedAt": "Publiziert um: ",
    "timeAccuracy": "Genauigkeit des Zeitpunkts",
    "sourceOfInformation": "Herkunft der Information",
    "personInvolvement": "Personenbeteiligung",
    "otherDamages": "Andere Schäden",
    "damagedAssets": "Beschädigte Objekte",
    "otherDamagesComment": "Kommentar zu Anderer Schaden",
    "publicAvalancheWarningService": "Amtlicher Lawinenwarndienst",
    "publicAvalancheWarningServiceOutside": "Außerhalb des Beurteilungsgebiets des Lawinenwarndienstes",
    "dangerRating": "Gefahrenstufe",
    "avalancheProblem": "Lawinenproblem",
    "problemType": "Lawinenproblem",
    "aspects": "Expositionen",
    "elevationLowerBound": "Untere Höhengrenze",
    "elevationUpperBound": "Obere Höhengrenze",
    "snowpackStability": "Schneedeckenstabilität",
    "frequency": "Häufigkeit",
    "dangerPattern": "Gefahrenmuster",
    "reportStatus": "Status des Berichts",
    "publicExternalLinks": "Externe Links für die Öffentlichkeit",
    "privateExternalLinks": "Externe Links mit vertraulicher Information",
    "privateExternalDatabaseLinks": "Link zu externen Datenbanken",
    "generalInformationComment": "Kommentar zu Allgemeinen Informationen",
    "bulletinInformationComment": "Kommentar zu Informationen zum Lawinenbericht",
    "location": "Ort",
    "country": "Land",
    "region": "Region",
    "municipality": "Gemeinde",
    "avalancheRegion": "Kleinstregion",
    "latitude": "Breitengrad",
    "longitude": "Längengrad",
    "locationAccuracy": "Genauigkeit der Örtlichkeit",
    "lineCoordinatesText": "Koordinaten der Linie",
    "polygonCoordinatesText": "Koordinaten des Polygons",
    "locationInformationComment": "Kommentar zu den Ortsinformationen",
    "locationType": {
      "Point": "Punkt",
      "Line": "Linie",
      "Polygon": "Polygon"
    },
    "anonymousGroupIdentifier": "Anonyme Kennung der Gruppe",
    "groupAffiliation": "Gruppenzugehörigkeit",
    "groupType": "Art der Gruppe",
    "groupSize": "Gruppengröße",
    "groupSizeAccuracy": "Genauigkeit der Gruppengröße",
    "incidentTerrainType": "Charakter des Geländes",
    "typeOfControlledTerrain": "Art des gesicherten Geländes",
    "incidentActivity": "Aktivität",
    "travelDirection": "Bewegungsrichtung",
    "vehicleType": "Fahrzeugtyp",
    "avalancheGear": "Notfallausrüstung",
    "groupInformationComment": "Kommentar zur Gruppeninformation",
    "numberOfGroups": "Anzahl an Gruppen",
    "activities": "Aktivitäten",
    "terrainTypes": "Charakter des Geländes",
    "fatalities": "Todesopfer",
    "injuredSurvivors": "Verletzte Personen",
    "uninjuredSurvivors": "Unverletzte Personen",
    "caughtOnly": "Nur mitgerissen",
    "fullyBuried": "Komplett verschüttet",
    "partlyBuriedHeadCovered": "Teilverschüttet, aber Kopf verschüttet",
    "partlyBuriedHeadUncovered": "Teilverschüttet, Kopf frei",
    "partlyBuried": "Teilverschüttet",
    "numberInvolved": "Anzahl beteiligte Personen",
    "involvementsFatalitiesBurialsComment": "Kommentare zu Beteiligungen, Todesopfer und Verschüttungen",
    "caught": "Mitgerissen",
    "fatalInjured": "Schadensausmaß Personen",
    "burialDegree": "Grad der Verschüttung",
    "anonymousVictimIdentifier": "Anonyme Kennung der Person",
    "age": "Alter",
    "gender": "Geschlecht",
    "workingAtTime": "Während der Ausführung seiner Arbeit unterwegs",
    "leaderAtTime": "Als Führer unterwegs",
    "professionalCertification": "Berufliche Qualifikation",
    "avalancheTraining": "Lawinenausbildung",
    "yearsActive": "Jahre der Erfahrung",
    "transceiver": "Lawinenverschüttetensuchgerät (LVS)",
    "shovel": "Schaufel",
    "probe": "Sonde",
    "airbag": "Lawinenrucksack",
    "helmet": "Helm",
    "terrainTrap": "Geländefalle",
    "burialDepth": "Verschüttungstiefe",
    "burialDuration": "Verschüttungsdauer",
    "primaryLocationMethod": "Primäre Auffindungsmethode",
    "rescuedBy": "Gerettet/Geborgen durch",
    "medicalIntervention": "Medizinische Versorgung",
    "estimatedTimeOfDeath": "Todeszeitpunkt (geschätzt)",
    "causeOfDeath": "Todesursache",
    "respiratoryCavity": "Atemhöhle vohanden",
    "injurySeverity": "Ausmaß der Verletzung",
    "victimInformationComment": "Kommentar zu Opferinformationen",
    "multipleAvalanches": "Mehrere Lawinen",
    "avalancheSize": "Lawinengröße",
    "avalancheType": "Lawinenart",
    "relevantAvalancheProblem": "Relevantes Lawinenproblem",
    "trigger": "Auslösung",
    "natural": "Spontan",
    "person": "Person",
    "additionalLoad": "Zusatzbelastung",
    "explosives": "Sprengung",
    "vehicle": "Fahrzeug",
    "accidentalControlled": "Zufällig / absichtlich, kontrolliert",
    "remoteTriggering": "Fernauslösung",
    "startZoneAspect": "Exposition des Anrissgebiets",
    "startZoneAspectAccuracy": "Genauigkeit der Exposition",
    "startZoneElevation": "Seehöhe des Anrissgebiets",
    "startZoneElevationAccuracy": "Genauigkeit der Seehöhe",
    "startZoneIncline": "Hangneigung des Anrissgebiets",
    "startZoneTerrainType": "Geländeform im Anrissgebiet",
    "slabWidth": "Breite des Schneebretts",
    "crownDepthAvg": "Anrissmächtigkeit im Durchschnitt",
    "crownDepthMin": "Minimum der Anrissmächtigkeit",
    "crownDepthMax": "Maximum der Anrissmächtigkeit",
    "avalancheLength": "Länge der Lawine",
    "weakLayerName": "Name der Schwachschicht",
    "weakLayerGrainType1": "Kornform (1) der Schwachschicht",
    "weakLayerGrainSize1": "Korngröße (1) der Schwachschicht ",
    "weakLayerGrainType2": "Kornform (2) der Schwachschicht",
    "weakLayerGrainSize2": "Korngröße (2) der Schwachschicht",
    "weakLayerLocation": "Position der Schwachschicht in der Schneedecke",
    "bedSurfaceStepped": "Lawine in tiefere Schichten durchgerissen?",
    "startZoneMoisture": "Feuchtigkeit im Anrissgebiet",
    "depositMoisture": "Feuchtigkeit der Ablagerung",
    "depositHeight": "Höhe der Ablagerung",
    "depositWidth": "Breite der Ablagerung",
    "debrisType": "Art der Ablagerung",
    "debrisDensity": "Dichte der Ablagerung",
    "depositElevation": "Seehöhe der Ablagerung",
    "avalancheDetailsComment": "Kommentar zu Details der Lawine",
    "incidentLedePublic": "Kurzzusammenfassung veröffentlichen?",
    "incidentLede": "Kurzzusammenfassung des Ereignisses",
    "incidentDescriptionPublic": "Beschreibung des Lawinenereignisses veröffentlichen?",
    "incidentDescription": "Beschreibung des Lawinenereignisses",
    "weatherDescriptionPublic": "Beschreibung zum Wetter veröffentlichen?",
    "weatherDescription": "Beschreibung Wetter",
    "avalancheDescriptionPublic": "Beschreibung der Lawine veröffentlichen?",
    "avalancheDescription": "Beschreibung der Lawine",
    "snowpackDescriptionPublic": "Beschreibung der Schneedecke veröffentlichen?",
    "snowpackDescription": "Beschreibung der Schneedecke",
    "takeAwaysPublic": "Wichtigste Erkenntnisse veröffentlichen?",
    "takeAways": "Wichtigsten Erkenntnisse",
    "recentSlabAvalanches": "Frische Schneebrettlawinen",
    "signsOfInstability": "Alarmzeichen",
    "recentLoading": "Frische Zusatzbelastung",
    "criticalWarming": "Kritische Erwärmung",
    "incidentAnalysisComment": "Kommentar zur Ereignisanalyse",
    "uuid": "UUID",
    "dateAdded": "Datum hinzugefügt",
    "dateCreated": "Datum erstellt",
    "file": "Datei",
    "fileName": "Dateiname",
    "mediaType": "Art des Mediums",
    "attachmentTags": "Tags",
    "altText": "Alternativer Text",
    "credit": "Bildnachweis",
    "caption": "Überschrift",
    "public": "Öffentlich",
    "attachmentCategory": "Kategorie"
  },
  "incidentReportHelp": {
    "author": "",
    "authorAffiliation": "",
    "dateTime": "",
    "timeAccuracy": "Gib die Genauigkeit des Datums bzw. der Uhrzeit der Lawine an.",
    "sourceOfInformation": "Aus welchen Quellen stammen die Informationen?",
    "personInvolvement": " Wähle „Ja“, wenn die Lawine von Personen ausgelöst wurde (einschließlich Fernauslösung) oder Personen von den sich bewegenden Schneemassen erfasst wurden.",
    "otherDamages": "Wähle „Ja“, wenn die Lawine Sachschäden oder Schäden an anderen wertvollen Gütern verursacht hat.",
    "damagedAssets": "Art der beschädigten Objekte angeben.",
    "otherDamagesComment": "Gib zusätzliche Informationen zu den beschädigten Objekten an.",
    "publicAvalancheWarningService": " Name der Organisation, in deren Zuständigkeitsbereich sich die Lawine ereignet hat.",
    "publicAvalancheWarningServiceOutside": "Aktiviere dieses Feld, wenn sich das Ereignis außerhalb eines Vorhersagegebiets eines Lawinenwarndienstes ereignet hat.",
    "dangerRating": " Öffentlich verfügbare Lawinengefahrenstufe, die für Datum, Uhrzeit und Ort des Ereignisses gültig war (einschließlich Höhenlage und Exposition, falls vorhanden).",
    "avalancheProblem": " Wähle die für diesen Tag und Ort prognostizierten EAWS-Lawinenprobleme aus. Wähle „Keine“, wenn für diesen Tag keine Lawinenprobleme ausgegeben wurden.",
    "problemType": " Wähle die für diesen Tag und Ort prognostizierten EAWS-Lawinenprobleme aus. Wähle „Keine“, wenn für diesen Tag keine Lawinenprobleme ausgegeben wurden.",
    "aspects": "",
    "elevationLowerBound": "",
    "elevationUpperBound": "",
    "snowpackStability": "",
    "frequency": "",
    "dangerPattern": "Wähle die für diesen Tag und Ort prognostizierten Gefahrenmuster aus.",
    "reportStatus": " Entwurf: Noch nicht für die öffentliche Ansicht freigegeben; Phase der ersten Datenerfassung. Unvollständig: Nicht alle Informationen wurden eingegeben oder liegen bereits vor; öffentlich sichtbar, kann jedoch noch nicht verifizierte Informationen enthalten. In Prüfung: Alle Informationen wurden erfasst; wartet auf die Überprüfung durch eine verantwortliche Person. Abgeschlossen: Alle verfügbaren Informationen wurden ergänzt; endgültiger Status.",
    "publicExternalLinks": "",
    "privateExternalLinks": "",
    "privateExternalDatabaseLinks": "Verknüpft dieses Ereignis mit anderen Datenbanken.",
    "generalInformationComment": "Füge zusätzliche relevante Angaben hinzu.",
    "bulletinInformationComment": "Füge zusätzliche relevante Angaben hinzu.",
    "location": "Kurze Beschreibung des Ortes. Verwende den Namen des nächstgelegenen Berges oder eines markanten geografischen Merkmals.",
    "country": "",
    "region": "",
    "municipality": "",
    "avalancheRegion": "Kleinstregionen",
    "latitude": "Gib die Koordinaten des Mittelpunkts der Anrisskante an.",
    "longitude": "Gib die Koordinaten des Mittelpunkts der Anrisskante an.",
    "locationAccuracy": "Schätze die Genauigkeit der Koordinaten fèr Breiten- und Längengrade ab.",
    "lineCoordinatesText": "Gib die Koordinaten des Lawinenzugs an (ein Breiten-/Längengrad-Paar pro Zeile).",
    "polygonCoordinatesText": "Gib die Koordinaten des Lawinenumrisses an (ein Breiten-/Längengrad-Paar pro Zeile).",
    "locationInformationComment": "Füge zusätzliche relevante Angaben hinzu.",
    "anonymousGroupIdentifier": "Die anonyme Kennung dient dazu, die Gruppe im gesamten Bericht eindeutig zu identifizieren. Du kannst beispielsweise auf „Gruppe 1“, „Gruppe 2“ usw. verweisen. Falls hilfreich, kannst du zusätzliche Angaben ergänzen, um die Gruppen besser auseinanderzuhalten. Wenn sinnvoll, kannst du dieselbe anonyme Kennung auch in der Ereignisbeschreibung verwenden.",
    "groupAffiliation": "Wähle die Gruppe aus, zu der die Person gehörte.",
    "groupType": "Wähle die Option, die die Art der Gruppe am besten beschreibt.",
    "groupSize": "Gib die Gesamtzahl der Personen in der Gruppe an.",
    "groupSizeAccuracy": "Gib an, wie genau die Gruppengröße bekannt ist.",
    "incidentTerrainType": "Wähle die Geländeart aus, in der sich die Personen zum Zeitpunkt der Lawine befanden. Freies Gelände bezeichnet Bereiche ohne menschliche Infrastruktur.",
    "typeOfControlledTerrain": "",
    "incidentActivity": "",
    "travelDirection": "Bewegungsrichtung im Moment des Ereignisses",
    "vehicleType": "",
    "avalancheGear": "Zur grundlegenden Lawinennotfallausrüstung zählen LVS-Gerät, Schaufel und Sonde. Gib eine allgemeine Einschätzung ab, ob die Gruppe diese Ausrüstung mitgeführt hat. Diese Information stammt häufig von den Rettungskräften. Es ist nicht notwendig, die genaue Anzahl der Ausrüstungsgegenstände oder den Ausrüstungsstatus jeder einzelnen Person zu erheben. Entscheidend ist die grundlegende Frage: Hat die Gruppe Lawinenrettungsausrüstung mitgeführt?",
    "groupInformationComment": "Füge zusätzliche relevante Angaben hinzu.",
    "numberOfGroups": "Anzahl der beteiligten Gruppen",
    "activities": "",
    "terrainTypes": "",
    "fatalities": "Alle Verstorbenen, unabhängig davon, ob sie am Unfallort oder später infolge ihrer Verletzungen verstorben sind.",
    "injuredSurvivors": "Anzahl der von der Lawine erfassten und verletzten Personen (ohne Verstorbene).",
    "uninjuredSurvivors": "Anzahl der von der Lawine erfassten, aber nicht verletzten Personen. Dazu zählen auch Personen, die lediglich von der Staubwolke erfasst wurden.",
    "caughtOnly": "Anzahl der von der Lawine erfassten, aber nicht verschütteten Personen. Dazu zählen auch Personen, die lediglich von der Staubwolke erfasst wurden.",
    "fullyBuried": "Anzahl der von der Lawine vollständig verschütteten Personen. Eine Person gilt als vollständig verschüttet, wenn kein Körperteil sichtbar ist.",
    "partlyBuriedHeadCovered": "Anzahl der Personen, die so verschüttet wurden, dass ihr Kopf von Schnee bedeckt war, aber Teile des Körpers, der Kleidung oder der mitgeführten Ausrüstung sichtbar blieben.",
    "partlyBuriedHeadUncovered": "Anzahl der Personen, die verschüttet wurden, deren Kopf jedoch nicht von Schnee bedeckt war.",
    "partlyBuried": "Anzahl=Teilverschüttet, Kopf verschüttet, sonst teilverschüttet (= sichtbar ganz verschüttet), Kopf nicht verschüttet",
    "numberInvolved": "Anzahl=Nur mitgerissen+Ganzverschüttet+Teilverschüttet",
    "involvementsFatalitiesBurialsComment": "Füge zusätzliche relevante Angaben hinzu.",
    "caught": "Gib an, ob diese Person von der Lawine betroffen war. Als betroffen gilt eine Person, wenn sie von der Lawine erfasst wurde (unabhängig davon, ob sie verschüttet wurde oder nicht), verschüttet wurde oder nur vom Staubanteil erfasst wurde.",
    "fatalInjured": "Gib an, ob die Person tödlich verletzt wurde, verletzt wurde oder unverletzt blieb – unabhängig davon, in welcher Weise sie von der Lawine betroffen war.",
    "burialDegree": "Gib den Verschüttungsgrad an. Eine Person gilt als vollständig verschüttet, wenn ihr gesamter Körper von Schnee bedeckt ist. Bei einer Teilverschüttung sollte nach Möglichkeit angegeben werden, ob der Kopf bedeckt oder unbedeckt war; diese Optionen sind bevorzugt zu verwenden. Ist diese Information nicht verfügbar, wähle die Option „Teilverschüttet“.",
    "anonymousVictimIdentifier": " Diese Bezeichnung dient dazu, die betroffene Person im gesamten Bericht eindeutig zu identifizieren, ohne ihren Namen zu verwenden. Verwende beispielsweise „Person 1“, „Person 2“ usw. oder – bei einem Schneemobilunfall – „Fahrer:in 1“, „Fahrer:in 2“. Falls hilfreich, kannst du ergänzende Angaben hinzufügen, um die Personen besser auseinanderzuhalten, z. B. „männlicher Überlebender“, „weibliche Überlebende“ oder „männlicher Verstorbener“. Wenn passend, kannst du dieselbe Bezeichnung auch in der Unfallbeschreibung verwenden.",
    "age": "",
    "gender": "",
    "workingAtTime": "Gib an, ob die Person zum Zeitpunkt des Ereignisses beruflich tätig war – entweder in einer bezahlten Funktion oder im Rahmen einer ehrenamtlichen Tätigkeit.",
    "leaderAtTime": "Gib an, ob die Person zum Zeitpunkt des Ereignisses eine klar erkennbare Führungsrolle innerhalb der Gruppe innehatte.",
    "professionalCertification": "Gib die berufliche Qualifikation bzw. Zertifizierung der Person an.",
    "avalancheTraining": "Gib die höchste absolvierte Ausbildung im Bereich Lawinen-Notfall an",
    "yearsActive": "Wähle aus, über wie viele Jahre Erfahrung die Person in dieser Aktivität vor dem Ereignis verfügte.",
    "transceiver": "Gib an, ob die Person ein LVS-Gerät mitführte und ob dieses auf Senden gestellt war.",
    "shovel": "",
    "probe": "",
    "airbag": "",
    "helmet": "",
    "terrainTrap": "Falls eine Geländefalle Teil des Ereignisses war, gib bitte an um welche es sich handelte.",
    "burialDepth": "Gib die Verschüttungstiefe in Metern auf 0,1 m genau an. Maßgebend für die Bestimmung der Verschüttungstiefe ist der Abstand zwischen Schneeoberfläche und den Atemwegen der verschütteten Person.",
    "burialDuration": "Gib die Verschüttungsdauer der betroffenen Person in Minuten an. Die Verschüttungsdauer umfasst den Zeitraum von der ersten Verschüttung bis zur Freilegung der Atemwege.",
    "primaryLocationMethod": "Gib die primäre Methode an, mit der die betroffene Person lokalisiert wurde.",
    "rescuedBy": "",
    "medicalIntervention": "Gib an, welche medizinischen Maßnahmen durchgeführt wurden – entweder durch Gruppenmitglieder oder durch die Rettungskräfte.",
    "estimatedTimeOfDeath": "Gib möglichst genau an, wann die betroffene Person verstorben ist. Diese Angabe muss nicht mit dem offiziellen Todeszeitpunkt übereinstimmen, da Personen in vielen Fällen erst im Krankenhaus für tot erklärt werden.",
    "causeOfDeath": "Vermutete Todesursache",
    "respiratoryCavity": "Atemwege frei",
    "injurySeverity": "Schwer: Eine schwere, oft lebensbedrohliche Verletzung, die sofortige medizinische Versorgung erfordert und zu dauerhaften Beeinträchtigungen oder zum Tod führen kann (z. B. Knochenbrüche, Kopfverletzungen, Bewusstlosigkeit, starke Blutungen). Mittel: Eine Verletzung, die schwerwiegender als eine leichte Verletzung ist, aber nicht unmittelbar lebensbedrohlich. In der Regel ist eine medizinische Behandlung erforderlich, eine vollständige Genesung ohne größere Langzeitfolgen wird jedoch erwartet (z. B. Luxationen, Verstauchungen oder Zerrungen, tiefe Schnittverletzungen). Leicht: Eine geringfügige Verletzung, die mit einfachen Erste-Hilfe-Maßnahmen behandelt werden kann und keine professionelle medizinische Versorgung erfordert (z. B. kleine Schnitte, Schürfwunden oder Prellungen).",
    "victimInformationComment": "Füge zusätzliche relevante Angaben hinzu.",
    "multipleAvalanches": "Wähle „Ja“, wenn das Ereignis mit mehreren Lawinen verbunden war. Gib in diesem Fall die Angaben zur folgenreichsten Lawine im Abschnitt „Lawinendetails“ ein und beschreibe die weiteren Lawinen im Abschnitt „Lawinenkommentare“.",
    "avalancheSize": "Schätze das Zerstörungspotenzial der Lawine anhand der Ablagerung ein und ordne die Lawine gemäß EAWS-Standard einer Größe zu. Größe 1 ist die kleinste Klasse. Halbe Größen sind grundsätzlich nicht definiert, können aber für Lawinen verwendet werden, die zwischen zwei Größenklassen liegen; sie werden der niedrigeren Klasse zugeordnet (z. B. wird Größe 2,5 als Größe 2 klassifiziert).",
    "avalancheType": "Wähle die Lawinenart entsprechend des Auslösemechanismus aus der Liste aus. Trifft mehr als eine Art zu, wähle den am besten passenden aus und ergänze weitere Details in der Ereignisbeschreibung.",
    "relevantAvalancheProblem": "Wähle das relevanteste EAWS Lawinenproblem aus.",
    "trigger": "Spontan: Ohne menschlichen Einfluss ausgelöst. Person: Durch eine oder mehrere Personen ausgelöst. Sprengung: Durch Sprengstoff, Artillerie oder Gas ausgelöst. Fahrzeug: Durch ein Fahrzeug ausgelöst (z. B. Pistenfahrzeug oder Hubschrauber). Unbekannt: Auslöser ist unbekannt oder unklar.",
    "natural": "Spontan: Ausgelöst durch Wetterereignisse (z. B. Schneefall, Wind, Temperatur); Wechtenbruch: Ausgelöst durch den spontanen Bruch einer Wechte; Erdbeben: Ausgelöst durch ein Erdbeben; Eissturz: Ausgelöst durch das Abbrechen von Eis; Steinschlag: Ausgelöst durch einen Steinschlag",
    "person": "Unbeabsichtigt: z. B. Skifahrer, Snowboardfahrer, Wanderer, Kletterer.\nAbsichtlich: z. B. ein Skifahrer, der einen Hang oder eine Wechte durch Ski Cutting gezielt auslöst.",
    "additionalLoad": "Geringe Zusatzbelastung: Einzelne Skifahrer:in oder Snowboarder:in, Guppe mit mindestens 10 m Abstand zwischen den Personen oder einzelne Schneeschuhgeher:in. Große Zusatzbelastung: Eng beieinander gehende Gruppe mit weniger als 10 m Abstand, einzelne Person zu Fuß oder stürzende Skifahrer:in bzw. Snowboarder:in.",
    "explosives": "",
    "vehicle": "",
    "accidentalControlled": "",
    "remoteTriggering": "Eine Fernauslösung liegt vor, wenn die Lawine in einiger Entfernung (in der Regel mehr als 5 m) von der vermuteten Auslösestelle ausgelöst wird. Der Schnee an der Auslösestelle selbst bricht dabei nicht an.",
    "startZoneAspect": "Gib die Exposition des Anrissgebiets an. Erstreckt sich die Lawine über mehrere Expositionen, verwende die mittlere Exposition und ergänze weitere Details in der Ereignisbeschreibung.",
    "startZoneAspectAccuracy": "Gib an, ob die Exposition des Anrissgebiets sicher oder unsicher ist. Als unsicher gilt die Angabe, wenn Abweichungen von mehr als ±30° möglich sind.",
    "startZoneElevation": "Gib die Höhe der Anrisskante in Metern über dem Meeresspiegel (m ü. M.) an. Verwende den höchsten Punkt der Anrisskante und runde auf die nächsten 50 m (z. B. 2550 m oder 2600 m).",
    "startZoneElevationAccuracy": "",
    "startZoneIncline": " Hangneigung im Anrissgebiet (°), auf die nächsten 5° gerundet (z. B. 30°, 35°, 40°).",
    "startZoneTerrainType": "Wähle die Geländeformen aus, die das Anrissgebiet der Lawine beschreiben.",
    "slabWidth": "Breite des Schneebretts in Metern. Diese kann anhand von Geländebeobachtungen geschätzt oder mithilfe der Koordinaten der Flanken kartografisch bestimmt werden.",
    "crownDepthAvg": " Mittlere Anrisstiefe in cm, vertikal gemessen und auf die nächsten 10 cm gerundet. Dieser Wert kann anhand von Geländebeobachtungen geschätzt werden (wird nur ein Wert für die Anrisstiefe angegeben, entspricht dieser in der Regel der mittleren Anrissmächtigkeit) oder wenn möglich aus der minimalen und maximalen Anrisstiefe berechnet werden.",
    "crownDepthMin": "Minimale Anrisstiefe in cm, vertikal gemessen und auf die nächsten 10 cm gerundet. Dieser Wert wird üblicherweise anhand von Geländebeobachtungen geschätzt.",
    "crownDepthMax": "Maximale Anrisstiefe in cm, vertikal gemessen und auf die nächsten 10 cm gerundet. Dieser Wert wird üblicherweise anhand von Geländebeobachtungen geschätzt.",
    "avalancheLength": " Auslauflänge entlang des Geländes vom höchsten Punkt der Anrisskante bis zum tiefsten Punkt der Ablagerung (in m). Dieser Wert kann anhand von Geländebeobachtungen geschätzt oder mithilfe der kartierten Koordinaten des Anrissgebiets und des Endpunkts der Ablagerung bestimmt werden.",
    "weakLayerName": "Gib die Kennung/den Namen der Schwachschicht an, sofern bekannt.",
    "weakLayerGrainType1": "1. Kornform der Schwachschicht",
    "weakLayerGrainSize1": "Korngröße auf 0,25 mm runden.",
    "weakLayerGrainType2": "2. Kornform der Schwachschicht",
    "weakLayerGrainSize2": "Korngröße auf 0,25 mm runden.",
    "weakLayerLocation": "Innerhalb des Neuschnees: Die Schwachschicht befindet sich innerhalb des kürzlich gefallenen oder verfrachteten Schnees aus der aktuellen Schneefall- bzw. Verfrachtungsperiode; an der Grenzfläche zum Altschnee: Die Schwachschicht liegt an der Grenze zwischen Neu- und Altschnee (z. B. Oberflächenreif auf der Altschneeoberfläche vor der Überdeckung); innerhalb der Altschneedecke: Die Schwachschicht befindet sich im mittleren oder oberen Bereich der Altschneedecke; bodennah: Die Schwachschicht liegt im unteren Bereich der Schneedecke nahe am Boden und besteht typischerweise aus ausgeprägten kantigen Kristallen. Lawinen, die auf dieser Schwachschicht anreißen, legen häufig den Boden frei.",
    "bedSurfaceStepped": "Wähle „Ja“, wenn die Lawine in eine tiefer liegende Schwachschicht durchgerissen ist.",
    "startZoneMoisture": "",
    "depositMoisture": "",
    "depositHeight": "Maximale Höhe der Ablagerung",
    "depositWidth": "Maximale Breite der Ablagerung",
    "debrisType": "Wähle die Optionen aus, die die Zusammensetzung der Lawinenablagerung kurz nach dem Lawinenabgang am besten beschreiben.",
    "debrisDensity": "Dichte der Lawinenablagerung, angegeben als Median mehrerer Messungen an verschiedenen Stellen der Ablagerung.",
    "depositElevation": "Höhe des tiefsten Punkts der Lawinenablagerung in Metern über dem Meeresspiegel (m ü. M.).",
    "avalancheDetailsComment": "Füge zusätzliche relevante Angaben hinzu.",
    "incidentLedePublic": "",
    "incidentLede": "Kurze Beschreibung des Ereignisses (max. 500 Zeichen), die dessen wesentliche Merkmale zusammenfasst. Beschreibe, was passiert ist sowie wann und wo sich das Ereignis ereignet hat und warum es bemerkenswert ist. Formuliere den Text kurz und sachlich und hebe die wichtigsten Aspekte hervor (z. B. Beteiligung von Personen, Verschüttung, Todesfälle oder außergewöhnliche Umstände).",
    "incidentDescriptionPublic": "",
    "incidentDescription": "Beschreibe das Ereignis klar und in chronologischer Reihenfolge, ohne Wertungen oder Schuldzuweisungen. Gib an, was die Gruppe zum Zeitpunkt des Ereignisses tat, wo sie sich befand (Gelände, Höhenlage und Exposition, sofern bekannt), wie die Lawine ausgelöst wurde, wie viele Personen betroffen, verschüttet, verletzt oder getötet wurden, wer die Rettung durchführte und wie diese ablief. Ergänze außerdem alle weiteren relevanten Beobachtungen, die zum Verständnis und zur Rekonstruktion des Ereignisses beitragen.",
    "weatherDescriptionPublic": "",
    "weatherDescription": "Beschreibe die Wetterbedingungen, die die Lawinenauslösung beeinflusst haben. Gehe dabei insbesondere auf Faktoren wie die Bildung der Schwachschicht, die Entwicklung des Schneebretts, die jüngste Zusatzbelastung der Schneedecke oder Erwärmung ein. Verweise gegebenenfalls auf relevante Anhänge (z. B. Wetterstationsdaten oder Diagramme).",
    "avalancheDescriptionPublic": "",
    "avalancheDescription": "Beschreibe die Lawine(n) sachlich und mit klaren, objektiven Begriffen. Gib Lawinenart, Größe und Abmessungen (z. B. Breite, Anrisstiefe und Auslauflänge) an. Beschreibe außerdem, wodurch die Lawine ausgelöst wurde (spontan, durch Personen, Fernauslösung) und wie sie sich entwickelt hat (z. B. Bruchausbreitung oder Ausdehnung). Ergänze alle messbaren oder beobachteten Merkmale. Angaben dazu, wie und wo Personen erfasst wurden sowie Details zur Rettung, gehören in die Ereignisbeschreibung.",
    "snowpackDescriptionPublic": "",
    "snowpackDescription": "Beschreibe den Aufbau und die Eigenschaften der Schneedecke, die zum Lawinenabgang beigetragen haben. Gehe dabei auf relevante Schwachschichten und die Eigenschaften des Schneebretts ein und beschreibe deren Verteilung (z. B. nach Höhenlage oder Exposition). Nenne vorhandene Alarmzeichen sowie verfügbare Ergebnisse durch Schneedeckentests. Der Schwerpunkt sollte darauf liegen zu erklären, warum die Schneedecke störanfällig war.",
    "takeAwaysPublic": "",
    "takeAways": "Fasse die wichtigsten Erkenntnisse aus dem Ereignis in wenigen kurzen Stichpunkten zusammen. Gehe dabei beispielsweise auf Alarmzeichen, Risikomanagement (z. B. einzeln abfahren), die Verwendung der Lawinennotfallausrüstung, Geländefallen oder die Zusammensetzung der Gruppe ein.",
    "recentSlabAvalanches": "Beantworte die Frage nach best-möglichem Ermessen: Gibt es in der Region Hinweise auf Schneebrettlawinen von heute oder gestern? Berücksichtige dabei Informationen der betroffenen Gruppe selbst, Berichte von Rettungskräften oder Beobachtungen anderer Personen im Gebiet, die darauf hinweisen, ob weitere Lawinen festgestellt wurden.",
    "signsOfInstability": "Beantworte die Frage nach best-möglichem Ermessen: Gibt es Hinweise auf eine instabile Schneedecke, wie Wummgeräusche, Rissbildung oder Zischgeräusche? Berücksichtige dabei Informationen der betroffenen Gruppe selbst, Berichte von Rettungskräften oder Beobachtungen anderer Personen im Gebiet, die auf solche Instabilitätszeichen hinweisen.",
    "recentLoading": "Beantworte die Frage nach best-möglichem Ermessen: Hat es in den letzten 48 Stunden eine Zusatzbelastung der Schneedecke gegeben, beispielsweise durch etwa 30 cm oder mehr Neuschnee, erhebliche Windverfrachtung oder Regen?",
    "criticalWarming": "Beantworte die Frage nach best-möglichem Ermessen: Gab es in jüngster Zeit einen raschen Temperaturanstieg bis nahe 0 °C oder ist die oberste Schneedecke infolge starker Sonneneinstrahlung, Temperaturen über dem Gefrierpunkt oder Regen durchfeuchtet?",
    "incidentAnalysisComment": "Für weitere Informationen",
    "uuid": "UUID",
    "dateAdded": "Das Datum wird aus dem Zeitpunkt des Hochladens des Anhangs übernommen.",
    "dateCreated": "Datum, an dem der Anhang erstellt oder aufgenommen wurde.",
    "file": "Datei",
    "fileName": "Wird aus dem ursprünglichen Dateinamen des hochgeladenen Anhangs übernommen.",
    "mediaType": "",
    "attachmentTags": "",
    "altText": "",
    "credit": "",
    "caption": "",
    "public": "",
    "attachmentCategory": ""
  },
  "sourceOfInformation": {
    "PublicObservation": " Öffentliche Beobachtung",
    "AWSInternal": "Lawienwarndienst intern",
    "AWSObserver": "Beobachter des Lawinenwarndienstes",
    "DispatchCentre": "Leitstelle",
    "Police": "Polizei",
    "MountainRescue": "Bergrettung",
    "Other": "Andere"
  },
  "personInvolvement": {
    "Yes": "Ereignis mit Personenbeteiligung",
    "No": "Keine Personenbeteiligung",
    "Unknown": "Ereignis (unbekannt)"
  },
  "otherDamages": {
    "Yes": "Ja",
    "No": "Nein"
  },
  "damagedAssets": {
    "Vehicle": "Fahrzeug",
    "Forest": "Wald ",
    "Agriculture": "Landwirtschaft",
    "Livestock": "Vieh",
    "UtilitiesTechnicalInfrastructure": "Technische Infrastruktur und Versorgungseinrichtungen",
    "ResidentialBuilding": "Wohngebäude",
    "Other": "Andere"
  },
  "timeAccuracy": {
    "exact": "exakt",
    "PT15M": "± 15 min",
    "PT30M": "± 30 min",
    "PT1H": "± 1 h",
    "PT2H": "± 2 h",
    "PT4H": "± 4 h",
    "PT6H": "± 6 h",
    "PT12H": "± 12 h",
    "P1D": "± 1 d",
    "P2D": "± 2 d",
    "P3D": "± 3 d",
    "unknown": "unbekannt"
  },
  "reportStatus": {
    "Draft": "Entwurf",
    "Incomplete": "Unvollständig",
    "InReview": "In Begutachtung",
    "Verified": "Überprüft"
  },
  "locationAccuracy": {
    "exact": "exakt",
    "within15m": "± 15 m",
    "within30m": "± 30 m",
    "within100m": "± 100 m",
    "within250m": "± 250 m",
    "within500m": "± 500 m",
    "within1km": "± 1 km",
    "within2km": "± 2 km",
    "within5km": "± 5 km",
    "within10km": "± 10 km",
    "within20km": "± 20 km",
    "within50km": "± 50 km",
    "unknown": "unbekannt"
  },
  "groupType": {
    "RecreationalFamilyFriends": "Freizeit Familie/Freunde",
    "Club": "Verein",
    "Commercial": "Kommerziell",
    "Industrial": "Industrie",
    "Solo": "Solo",
    "Unknown": "unbekannt",
    "Other": "Andere"
  },
  "groupSizeAccuracy": {
    "Exact": "Exakt",
    "Approximately": "Ungefähr",
    "AtLeast": "Zumindest",
    "Unknown": "unbekannt"
  },
  "incidentTerrainType": {
    "FreeTerrain": "Freies Gelände",
    "ControlledTerrainOpen": "Gesichertes Gelände: Geöffnet",
    "ControlledTerrainClosed": "Gesichertes Gelände: Gesperrt",
    "Unknown": "unbekannt"
  },
  "typeOfControlledTerrain": {
    "IndoorInsideBuilding": "In einem Gebäude",
    "Street": "Straße",
    "TrainTrack": "Zuggleis",
    "SkiAreaResort": "Skigebiet",
    "CrossCountryTrack": "Langlaufloipe",
    "SledgingTrack": "Rodelbahn",
    "Other": "Andere"
  },
  "incidentActivity": {
    "Touring": "Skitour",
    "Freeriding": "Variante",
    "SkiingSnowboarding": "Skifahren/Snowboarden",
    "Snowmobiling": "Schneemobil",
    "Mountaineering": "Bergsteigen",
    "IceClimbing": "Eisklettern",
    "Snowshoeing": "Schneeschuhwandern",
    "HikingOnFoot": "Wandern (zu Fuß)",
    "CrossCountrySkiing": "Langlaufen",
    "HuntingFishing": "Jagen/Fischen",
    "Sledging": "Rodeln",
    "Snowbiking": "Snowbiking",
    "Biking": "Fahrradfahren",
    "InsideVehicle": "Im Fahrzeug",
    "Unknown": "unbekannt",
    "Other": "Andere"
  },
  "travelDirection": {
    "Ascending": "Aufsteigend",
    "Descending": "Abfahrend",
    "Stationary": "Stillstehend",
    "Traversing": "Querend",
    "MovingOnPeaksRidges": "Sich auf Gipfel/Grate bewegend",
    "SnowmobileHighMarking": "Snowmobile High Marking",
    "CrossingRunouts": "Lawinenausläufe kreuzend",
    "Other": "Andere"
  },
  "vehicleType": {
    "Car": "Auto",
    "Bus": "Bus",
    "SnowPlower": "Schneepflug",
    "Snowcat": "Pistengerät",
    "Other": "Andere"
  },
  "avalancheGear": {
    "All": "Alle",
    "Some": "Wenig",
    "None": "Keine",
    "Unknown": "unbekannt"
  },
  "natural": {
    "Natural": "Spontan (Ergebnis von Wetterereignissen, z.B. Neuschnee, Wind, Temperatur)",
    "CorniceFall": "Wechtenbruch, spontan",
    "Earthquake": "Erdbeben",
    "IceFall": "Eisabbruch",
    "RockFall": "Steinschlag"
  },
  "person": {
    "PersonAccidental": "Zufällig",
    "PersonControlled": "Kontrolliert"
  },
  "explosives": {
    "Artillery": "Artillerie",
    "CaseCharge": "Sprengladung im Sack am Hangfuß platziert",
    "CorniceControlledByExplosives": "Wechte, durch Sprengung ausgelöst",
    "HelicopterDeployedGasExploder": "Helikoptergestütztes Gassprengsystem (z. B. DaisyBell)",
    "HandThrownOrPlaced": "Handladung",
    "GasExploder": "Gassprengssystem",
    "HelicopterBomb": "Ladung von Hubschrauber deponiert",
    "Avalauncher": "Avalauncher oder andere Arten von Werfern",
    "PrePlacedRemotelyDetonated": "Vorinstallierte, ferngezündete Sprengladung",
    "TramOrRopewayDelivery": "Sprengseilbahn",
    "Other": "Andere"
  },
  "vehicle": {
    "OverSnowVehicle": "Schneefahrzeug (Pistengerät, Wartungsequipment, etc.)",
    "Snowmobile": "Schneemobil",
    "Helicopter": "Hubschrauber (z.B. beim Landen oder Annähern)",
    "Other": "Andere"
  },
  "startZoneElevationAccuracy": {
    "exact": "exakt",
    "within50m": "± 50 m",
    "within100m": "± 100 m",
    "within200m": "± 200 m",
    "unknown": "unbekannt"
  },
  "startZoneTerrainType": {
    "AlpineBowl": "Kar",
    "Couloir": "Rinne",
    "NearRidgeCrest": "Kammnaher Bereich",
    "SparselyTreed": "Lichter Wald",
    "OpenForest": "Offener Wald",
    "DenseForest": "Dichter Wald",
    "ForestGlade": "Waldlichtung",
    "Glacier": "Gletscher",
    "OpenSlope": "Offenes Gelände",
    "Ridge": "Kamm",
    "ExtremeRockyTerrain": "Felsdurchsetztes Gelände",
    "BaseOfRockFace": "Felswandfuss",
    "WoodPath": "Forstweg",
    "LeewardSlope": "Windgeschützter Hang",
    "WindwardSlope": "Windzugewandter Hang",
    "IceWaterfall": "Eisfall",
    "Other": "Andere"
  },
  "weakLayerLocation": {
    "WithinNewSnow": "Innerhalb des Neuschnees",
    "AtInterfaceWithOldSnow": "Am Übergang zum Altschnee",
    "WithinOldSnowpack": "Innerhalb der Altschneedecke",
    "NearTheGround": "Bodennah"
  },
  "debrisType": {
    "Fine": "Fein",
    "Blocks": "Blockig",
    "Hard": "Hart",
    "Soft": "Weich",
    "Rocks": "Steine",
    "Trees": "Bäume",
    "Other": "Andere"
  },
  "startZoneMoisture": {
    "Dry": "Trocken",
    "Moist": "Feucht",
    "Wet": "Nass",
    "Unknown": "unbekannt"
  },
  "depositMoisture": {
    "Dry": "Trocken",
    "Moist": "Feucht",
    "Wet": "Nass"
  },
  "bedSurfaceStepped": {
    "Yes": "Ja",
    "No": "Nein"
  },
  "multipleAvalanches": {
    "Yes": "Ja",
    "No": "Nein"
  },
  "avalancheType": {
    "slab": "Schneebrett",
    "loose": "Lockerschneelawine",
    "glide": "Gleitschneelawine",
    "cornice": "Wechte",
    "unknown": "unbekannt"
  },
  "avalancheSize": {
    "small": "klein",
    "small_medium": "klein–mittel",
    "medium": "mittel",
    "medium_large": "mittel–groß",
    "large": "groß",
    "large_very_large": "groß–sehr groß",
    "very_large": "sehr groß",
    "very_large_extreme": "sehr groß–extrem",
    "extreme": "extrem",
    "unknown": "unbekannt"
  },
  "trigger": {
    "natural": "Spontan",
    "person": "Person",
    "explosives": "Spregung",
    "vehicle": "Fahrzeug",
    "unknown": "unbekannt",
    "Other": "Andere"
  },
  "startZoneAspectAccuracy": {
    "Accurate": "Genau",
    "Uncertain": "Ungenau"
  },
  "remoteTriggering": {
    "Yes": "Ja",
    "No": "Nein"
  },
  "additionalLoad": {
    "High": "Groß",
    "Low": "Gering"
  },
  "accidentalControlled": {
    "Accidental": "Zufällig",
    "Controlled": "Kontrolliert"
  },
  "caught": {
    "Involved": "Beteiligt",
    "NotInvolved": "Unbeteiligt",
    "Unknown": "unbekannt"
  },
  "fatalInjured": {
    "Fatal": "Tödlich",
    "Injured": "Verletzt",
    "Uninjured": "Unverletzt",
    "Unknown": "unbekannt"
  },
  "burialDegree": {
    "FullyBuried": "Komplett verschüttet",
    "PartlyBuriedHeadCovered": "Teilverschüttet, aber Kopf verschüttet",
    "PartlyBuriedHeadUncovered": "Teilverschüttet, Kopf frei",
    "PartlyBuried": "Teilverschüttet",
    "NotBuried": "Nicht verschüttet",
    "Unknown": "unbekannt"
  },
  "age": {
    "UpTo13": "≤ 13",
    "From14To20": "14–20",
    "From21To30": "21–30",
    "From31To40": "31–40",
    "From41To50": "41–50",
    "From51To60": "51–60",
    "From61To70": "61–70",
    "From71": "≥ 71"
  },
  "gender": {
    "Female": "Weiblich",
    "Male": "Männlich",
    "Other": "Andere"
  },
  "country": {
    "Austria": "Österreich",
    "Germany": "Deutschland",
    "Italy": "Italien",
    "Switzerland": "Schweiz",
    "Other": "Andere"
  },
  "workingAtTime": {
    "Yes": "Ja",
    "No": "Nein"
  },
  "leaderAtTime": {
    "Yes": "Ja",
    "No": "Nein"
  },
  "professionalCertification": {
    "None": "Keiner",
    "IFMGAGuide": "IVBV Bergführer:in",
    "FullSkiGuide": "Skiführer:in",
    "SkiInstructor": "Skilehrer:in",
    "ApprenticeGuide": "Bergführer:in Anwärter",
    "AvalancheProfessional": "Professionell ausgebildete Fachkraft für Lawinensicherheit",
    "AvalancheEducator": "Ausbildner Lawine",
    "Other": "Andere"
  },
  "avalancheTraining": {
    "None": "Keine",
    "Awareness": "Bewusstsein",
    "BasicREC": "Grundausbildung Freizeit",
    "AdvancedREC": "Fortgeschrittene Ausbildung Freizeit",
    "Professional": "Professionell",
    "Other": "Andere"
  },
  "yearsActive": {
    "UpTo2Years": "≤ 2 Jahre",
    "From3To9Years": "3–9 Jahre",
    "From10Years": "≥ 10 Jahre"
  },
  "transceiver": {
    "NoTransceiver": "Kein Lawinenverschüttetensuchgerät (LVS)",
    "TransceiverOn": "LVS: an",
    "TransceiverOff": "LVS: aus"
  },
  "shovel": {
    "Yes": "Ja",
    "No": "Nein"
  },
  "probe": {
    "Yes": "Ja",
    "No": "Nein"
  },
  "airbag": {
    "NoAirbag": "Kein Lawinenairbag",
    "AirbagDeployed": "Lawinenairbag: aktiviert",
    "AirbagUndeployed": "Lawinenairbag: nicht aktiviert"
  },
  "helmet": {
    "Yes": "Ja",
    "No": "Nein"
  },
  "terrainTrap": {
    "None": "Keine",
    "Cliff": "Felswand",
    "Trees": "Bäume",
    "Gully": "Graben",
    "Depression": "Mulde",
    "Bench": "Geländestufe",
    "Boulder": "Felsblock",
    "CrevasseOrBergschrund": "Gletscherspalte oder Bergschrund",
    "Other": "Andere"
  },
  "primaryLocationMethod": {
    "NotBuried": "Nicht verschüttet",
    "SelfExtraction": "Selbst befreit",
    "VisualClues": "Mit Auge gefunden",
    "TransceiverProbeShovel": "LVS/Sonde/Schaufel",
    "SpotProbing": "Stichprobenartiges Sondieren",
    "ProbeLine": "Sondierkette",
    "Recco": "Recco",
    "RescueDog": "Lawinenhund",
    "Snowmelt": "Ausapern",
    "Other": "Andere"
  },
  "rescuedBy": {
    "Self": "Selbst",
    "Companion": "Kameradenrettung",
    "OtherGroup": "Andere Gruppe",
    "OrganizedRescue": "Organisierte Rettung",
    "Unknown": "unbekannt",
    "Other": "Andere"
  },
  "medicalIntervention": {
    "CPR": "Herz-Lungen-Reanimation",
    "ALS": "Erweiterte Wiederbelebungsmaßnahmen",
    "ECMO": "ECMO",
    "Other": "Andere"
  },
  "estimatedTimeOfDeath": {
    "DuringTheAvalanche": "Während des Lawinenabgangs",
    "DuringBurial": "Während der Verschüttung",
    "OnSiteAfterExtrication": "Am Unfallort nach der Bergung",
    "DuringTransport": "Während des Abtransports",
    "InHospital": "Im Krankenhaus"
  },
  "causeOfDeath": {
    "Asphyxiation": "Asphyxie",
    "TraumaticInjury": "Trauma",
    "Hypothermia": "Hypothermie",
    "Other": "Andere"
  },
  "respiratoryCavity": {
    "Yes": "Ja",
    "No": "Nein"
  },
  "injurySeverity": {
    "Minor": "Gering",
    "Moderate": "mäßig",
    "Major": "Gröber"
  },
  "recentSlabAvalanches": {
    "Present": "Anwesend",
    "Absent": "Abwesend",
    "Unknown": "unbekannt"
  },
  "signsOfInstability": {
    "Present": "Anwesend",
    "Absent": "Abwesend",
    "Unknown": "unbekannt"
  },
  "recentLoading": {
    "Present": "Anwesend",
    "Absent": "Abwesend",
    "Unknown": "unbekannt"
  },
  "criticalWarming": {
    "Present": "Anwesend",
    "Absent": "Abwesend",
    "Unknown": "unbekannt"
  },
  "attachmentTags": {
    "Picture": "Foto",
    "PoliceReport": "Polizeibericht",
    "MedicalReport": "Medizinischer Befund",
    "Other": "Andere"
  },
  "attachmentCategory": {
    "Incident": "Ereignis",
    "Avalanche": "Lawine",
    "Snowpack": "Schneedecke",
    "Group": "Gruppe",
    "Person": "Person",
    "Weather": "Wetter"
  }
}
